import store from '@/store'

// 定位
async function getLocation() {
  if (store.getters.location.city === '') {
    await store
      .dispatch('location/getLocation')
      .catch(err => {
        console.log(err)
      })
    // return result
  }
}

// 获取用户积分
async function getUsersurplus(to, from) {
  if (to.meta.isGetUserSurplus) {
    return store.dispatch('user/getUsersurplus')
  }
}
// 获取用户信息
async function getUserInfo() {
  if (Object.keys(store.getters.userInfo).length === 0) {
    return store.dispatch('user/getUserInfo')
  }
}
// 获取用户福利卡
async function getWelfareCards() {
  if (store.getters.welfareCards.length === 0) {
    await store.dispatch('user/getBalanceList')
  }
}
const locationPass = ['/paymentCashier', '/payOrderStatus']

const fetchUserData = async (to, from) => {
  const promises = []
  
  // 获取用户积分（条件加载）
  if (to.meta.isGetUserSurplus) {
    promises.push(getUsersurplus(to, from))
  }
  
  // 获取用户信息（如果不存在）
  if (Object.keys(store.getters.userInfo).length === 0) {
    promises.push(getUserInfo())
  }
  
  // 并行执行所有需要的操作，不阻塞主要流程
  if (promises.length > 0) {
    return Promise.all(promises)
  }
}

export default fetchUserData
